import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function OdysseyBuilderTradesTriggerFullDetails({ trigger }: Props) {
  const executedWhenDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        <Text as="span" variant="body-sm" color="muted">
          User trades on
        </Text>
        <Badge size="sm">Odyssey Finance</Badge>
        <Text as="span" variant="body-sm" color="muted">
          platform
        </Text>
      </div>
    );
  }, []);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
